var cjs = {exports: {}};

export { cjs as __module };
//# sourceMappingURL=index2.js.map
